export type VesselKind = "cup" | "bottle";

type VesselIconProps = {
  kind?: string | null;
  className?: string;
};

export function VesselIcon({ kind, className = "" }: VesselIconProps) {
  const normalizedKind: VesselKind = kind === "bottle" ? "bottle" : "cup";

  return (
    <span className={`vessel-icon vessel-icon--${normalizedKind} ${className}`} aria-hidden="true">
      <span />
    </span>
  );
}
